export const MAX_SITE_PAGES = 25;
export const MAX_CUSTOM_MENU_LINKS = 12;
export const MAX_HEADER_MENU_ITEMS = MAX_SITE_PAGES + MAX_CUSTOM_MENU_LINKS;
export const menuIconNames = ["none", "sparkles", "building", "sun", "layers", "bath", "shield", "window", "grid", "leaf", "briefcase", "camera"] as const;
export type MenuIcon = typeof menuIconNames[number];
